import { connect } from 'react-redux';
import { translate } from '../../../base/i18n/functions';
import { IconSubtitles } from '../../../base/icons/svg';
import { toggleLanguageSelectorDialog } from '../../actions.web';
import { isInterpretedCaptionRoom } from '../../functions';
import { AbstractClosedCaptionButton, _abstractMapStateToProps } from '../AbstractClosedCaptionButton';
/**
 * A button which starts/stops the transcriptions.
 *
 * In an interpreted room it is the one captions switch: shown without Jitsi's
 * transcription config, labelled "Captions" (its pressed state says on or
 * off), and a press toggles captions instead of opening the language picker.
 * It replaced the "CC Captions Off" control in the old floating room pill.
 */
class ClosedCaptionButton extends AbstractClosedCaptionButton {
    constructor() {
        super(...arguments);
        this.accessibilityLabel = 'toolbar.accessibilityLabel.cc';
        this.icon = IconSubtitles;
        this.tooltip = 'transcribing.ccButtonTooltip';
        this.label = 'toolbar.startSubtitles';
        this.labelProps = this.props._vrsCaptions ? {} : {
            language: this.props.t(this.props._language ?? 'transcribing.subtitlesOff'),
            languages: this.props.t(this.props.languages ?? ''),
            languagesHead: this.props.t(this.props.languagesHead ?? '')
        };
    }
    /**
     * Toggle language selection dialog.
     *
     * @returns {void}
     */
    _handleClickOpenLanguageSelector() {
        const { dispatch } = this.props;
        dispatch(toggleLanguageSelectorDialog());
    }
    /**
     * The label: a stable "Captions" in an interpreted room.
     *
     * @returns {string}
     */
    _getLabel() {
        return this.props._vrsCaptions ? 'toolbar.vrsCaptions' : super._getLabel();
    }
    /**
     * The accessibility label: a stable "Captions" in an interpreted room;
     * the button's pressed state carries on or off.
     *
     * @returns {string}
     */
    _getAccessibilityLabel() {
        return this.props._vrsCaptions ? 'toolbar.accessibilityLabel.vrsCaptions' : super._getAccessibilityLabel();
    }
    /**
     * The tooltip: what a press will do, in an interpreted room.
     *
     * @returns {string}
     */
    _getTooltip() {
        if (!this.props._vrsCaptions) {
            return super._getTooltip();
        }
        return this._isToggled() ? 'toolbar.vrsCaptionsTurnOff' : 'toolbar.vrsCaptionsTurnOn';
    }
}
/**
 * Maps state to props, adding the interpreted-room switch.
 *
 * @param {IReduxState} state - The redux state.
 * @param {IAbstractProps} ownProps - The component's own props.
 * @returns {Object}
 */
function _mapStateToProps(state, ownProps) {
    const props = _abstractMapStateToProps(state, ownProps);
    const vrsCaptions = isInterpretedCaptionRoom(state);
    return {
        ...props,
        _vrsCaptions: vrsCaptions,
        visible: ownProps.visible ?? (props.visible || vrsCaptions)
    };
}
export default translate(connect(_mapStateToProps)(ClosedCaptionButton));
